module.exports = __webpack_public_path__ + "img/processor-middle.ef3e2568.png";